import React from "react";

import styled from "styled-components";
import { media } from "./_includes/Device";
import moment from "moment";

const Section = styled.div``;

const Container = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  padding: 45px 20px;
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  position: relative;

  > * {
    max-width: 50%;
    width: 50%;
    flex-basis: 50%;
  }

  ${media.tablet`
    padding: 35px 20px 35px 20px;
    display: block;
    
    > *  {
    max-width: 100%;
    width: 100%;
    flex-basis: 100%;
  } 
  `};
`;

const Content = styled.div`
  padding: 100px 40px 100px 0;

  ${media.tablet`
    padding: 0;
  `};
`;

const DescriptionWrapper = styled.span`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: flex-start;
  margin-bottom: 30px;

  ${media.tablet`
    margin-bottom: 20px;
  `};
`;

const ItemDescription = styled.p`
  position: relative;
  margin-right: 35px;
  margin-bottom: 0;

  &:after {
    content: "";
    height: 2px;
    width: 15px;
    background-color: #333;
    position: absolute;
    right: -25px;
    top: 50%;
    transform: translateY(-50%);
  }
`;

const ItemSubDescription = styled.p`
  color: #999;
  margin-bottom: 0;

  &.small {
    font-weight: 400;
  }
`;

const JobTitle = styled.h1`
  text-transform: uppercase;
`;

const JobSubtitle = styled.h2`
  margin: 0;

  ${media.tablet`
    margin-bottom: 30px;
  `};
`;

const Image = styled.div`
  background-size: cover;
  background-position: center;
  border-radius: 15px 0 0 15px;
  position: absolute;
  left: 50%;
  top: 0;
  height: 100%;
  width: 50vw;
  max-width: 50vw;
  flex-basis: 50vw;
  background-color: #eee;

  ${media.tablet`
    position: relative;
    height: 200px;
    left: 0;
    right: -20px;
    width: calc(100% + 20px);
    max-width: calc(100% + 20px);
    flex-basis: calc(100% + 20px);
  `};
`;

const Date = styled.div`
  margin-top: -20px;
  margin-bottom: 15px;

  span {
    margin-right: 10px;

    &.date {
      font-weight: 900;
      font-size: 26px;
      color: #999;
    }

    &.time {
      color: transparent !important;
      -webkit-text-stroke-width: 1px;
      -webkit-text-stroke-color: #999;
      font-weight: 900;
      font-size: 26px;
    }
  }
`;

const Meetup = styled.a`
  margin-top: 30px;

  ${media.tablet`
    margin: 0 0 40px 0;
  `}
`;

export class JobHero extends React.Component {
  render() {
    let pageType = "Jobs";

    let title = this.props.title;
    let subtitle = "";
    let thumbnail = this.props.heroImage;
    let eventDates = {};

    if (this.props.type === "event") {
      let dateFormat = "DD MMM";
      let timeFormat = "HH:mm";

      pageType = "Events";

      title = this.props.event.data.title.text;
      subtitle = this.props.event.data.subtitle.text;
      thumbnail = this.props.event.data.thumbnail.url;

      eventDates = {
        startDates: {
          date: moment(this.props.event.data.start_date).format(dateFormat),
          time: moment(this.props.event.data.start_date).format(timeFormat)
        },
        endDates: {
          date: moment(this.props.event.data.end_date).format(dateFormat),
          time: moment(this.props.event.data.end_date).format(timeFormat)
        }
      };
    }

    return (
      <Section>
        <Container>
          <Content>
            {pageType === "Jobs" && (
              <DescriptionWrapper>
                <ItemDescription className={"small"}>
                  {pageType}
                </ItemDescription>
                <ItemSubDescription className={"small"}>
                  {title}
                </ItemSubDescription>
              </DescriptionWrapper>
            )}

            {pageType === "Events" && (
              <Date>
                <span className="date">{eventDates.startDates.date}</span>
                <span className="time">{eventDates.startDates.time}</span>

                {eventDates.startDates.date &&
                eventDates.endDates.date &&
                eventDates.startDates.date !== eventDates.endDates.date ? (
                  <span>
                    <span className="date">- {eventDates.endDates.date}</span>
                    <span className="time">{eventDates.endDates.time}</span>
                  </span>
                ) : (
                  <span className="time">- {eventDates.endDates.time}</span>
                )}
              </Date>
            )}

            <JobTitle>{title}</JobTitle>

            {pageType === "Jobs" && <h2>{this.props.location}</h2>}

            <JobSubtitle>{subtitle}</JobSubtitle>

            {this.props.event && this.props.event.data.external_link !== null && (
              <Meetup
                className={"btn"}
                href={this.props.event.data.external_link.url}
              >
                To sign up
              </Meetup>
            )}
          </Content>

          <Image style={{ backgroundImage: `url(${thumbnail})` }} />
        </Container>
      </Section>
    );
  }
}
